import TipsSlider from "./TipsSlider";
import { IMAGE_TYPES, IMAGE_TYPE_LABELS } from '~/constants/imageTypes';
import { TIPS_DATA } from '~/constants/tipsData';

interface TipsProps {
  isFrontInfo?: any;
  isBackInfo?: any;
  isSelfieInfo: any;
  isPassportInfo?: any;
  startCapture: (imageType: string) => void;
  back: () => void;
}

const Tips = ({ isFrontInfo, isBackInfo, isSelfieInfo, isPassportInfo, startCapture, back }: TipsProps) => {
  // Determine the current image type based on props
  const getCurrentImageType = () => {
    if (isFrontInfo) return IMAGE_TYPES.DL_FRONT;
    if (isBackInfo) return IMAGE_TYPES.DL_BACK;
    if (isSelfieInfo) return IMAGE_TYPES.SELFIE;
    if (isPassportInfo) return IMAGE_TYPES.PASSPORT;
    return null;
  };

  const currentImageType = getCurrentImageType();

  // Get the appropriate data based on current image type
  const getInfoItems = () => {
    return TIPS_DATA[currentImageType ?? ''] || [];
  };

  const getImageTypeLabel = () => {
    return IMAGE_TYPE_LABELS[currentImageType ?? ''] || '';
  };

  // Early return if no valid image type is determined
  if (!currentImageType) {
    return null;
  }

  return (
    <TipsSlider
      items={getInfoItems()}
      imageTypeLabel={getImageTypeLabel()}
      imageType={currentImageType}
      startCapture={startCapture}
      back={back}
    />
  );
};

export default Tips;
